<!--
 License Form embed in generic wrapper.

 Events:
  created: Triggered when the license is successfully created. Contains the new license in the payload
  error: Triggered when a attempt of creation fails. Contains an error message.

 Usage:
  Jade:
    license-form-dialog(ref="licenseDialog")

  Javascript:
    this.$refs.licenseDialog.open();
-->

<template lang="pug">
dialog-form(ref='domainForm', :saveAction="saveAction", title="Create License", @closed='resetForm')
  .modal-content
    md-layout.form-section(md-flex='100')
      metadata-form(:entity='license', :form-submitted='formSubmitted', :validations='$v.license')
    md-layout.form-section
      md-layout(md-flex="100")
        .md-headline Geographic Rules
      md-layout(md-flex="100")
        .md-subheading#approach Approach
      md-radio.md-primary(v-model='license.geoList.mode', md-value='allow') Allow
      md-radio.md-primary(v-model='license.geoList.mode', md-value='deny') Deny
      country-selector(v-model='license.geoList.countries')
    md-layout.form-section(md-flex='100')
      domains-form.domains-form(:entity='license')
    md-layout.form-section(md-flex='100')
      platforms-form.platforms-form(:entity='license')
    md-layout.form-section(md-flex='100')
      md-layout.status(md-flex='100')
        .md-headline Licensing Window
      status-radio(v-model='license.status')
      md-layout(md-flex='100', md-gutter='16', v-if="license.status === 'public'")
        md-layout(md-flex='50')
          date-input(v-model='license.startDate', :validation='$v.license.startDate', :formSubmitted='formSubmitted', label="Available from")
        md-layout(md-flex='50')
          date-input(v-model='license.endDate', :validation='$v.license.endDate', :formSubmitted='formSubmitted', label="Available until")
    md-layout.form-section(md-flex='100')
      pricing-form.pricing-form(:entity='license')
</template>

<script>
  import { validationMixin } from 'vuelidate';
  import { required } from 'vuelidate/lib/validators';
  import DialogForm from './DialogForm';
  import licenseService from '../../services/licenseService';
  import { isValidDate } from '../../services/validatorService';
  import DateInput from '../../shared-components/forms/DateInput'
  import MetadataForm from '../../shared-components/forms/MetadataForm';
  import DomainsForm from '../../shared-components/forms/DomainsForm';
  import PlatformsForm from '../../shared-components/forms/PlatformsForm';
  import PricingForm from '../../shared-components/forms/PricingForm';
  import CountrySelector from '../../shared-components/country/CountrySelector';
  import StatusRadio from '../../shared-components/StatusRadio';

  export default {
    mixins: [validationMixin],
    components: {
      DialogForm,
      MetadataForm,
      DomainsForm,
      PlatformsForm,
      PricingForm,
      CountrySelector,
      DateInput,
      StatusRadio
    },
    data() {
      return {
        license: {
          name: '',
          description: '',
          tags: [],
          status: 'public',
          startDate: '',
          endDate: '',
          outletList: {
            mode: 'whitelist',
            domainLists: []
          },
          geoList: {
            mode: 'deny',
            countries: []
          },
          platforms: { mobile_web: true, mobile_app: true, tablet: true, desktop: true, ott: true, connectedtv: true },
          pricing: [{ unit: 'cpm', countries: [], price: 0 }]
        },
        formSubmitted: false,
        nameOfAllLicences: []
      };
    },
    validations: {
      license: {
        name: {
          required,
          isUnique(value) {
            if (value) {
              return !this.nameOfAllLicences.includes(value);
            } else {
              return true;
            }
          }
        },
        shortDescription: {
          default:true
        },
        description: {
          default:true
        },
        startDate: {
          validDate(value) {
            if (this.license.status === 'public') {
              return value ? isValidDate(value) : false;
            } else {
              return true;
            }
          }
        },
        endDate: {
          validDate(value) {
            if (this.license.status === 'public') {
              return value ? isValidDate(value) : false;
            } else {
              return true;
            }
          }
        }
      }
    },
    methods: {
      open() {
        this.$refs.domainForm.openDialog();
      },
      resetForm() {
        this.license = {
          name: '',
          description: '',
          tags: [],
          status: 'public',
          startDate: '',
          endDate: '',
          outletList: {
            mode: 'whitelist',
            domainLists: []
          },
          geoList: {
            mode: 'deny',
            countries: []
          },
          platforms: { mobile: true, tablet: true, desktop: true, ott: true },
          pricing: [{ unit: 'cpm', countries: [], price: 0 }]
        };
        this.formSubmitted = false;
        this.$v.$reset();
      },
      async saveAction() {
        this.formSubmitted = true;
        if (this.$v.$invalid) {
          const error = { msg: 'Invalid form' };
          throw error;
        } else {
          try {
            const response = await licenseService.create(this.license);
            this.$emit('created', response.data.license);
            this.resetForm();
          } catch (e) {
            this.$emit('error', 'License creation failed. Please, try again later.');
            this.resetForm();
            throw e;
          }
        }
      }
    },
    mounted() {
      licenseService.getList()
        .then((response) => {
          const licensesNames = response.data.licenses.map((license) => license.name);
          this.nameOfAllLicences = licensesNames;
        })
    }
  };
</script>

<style lang="scss" scoped>
  .modal-content {
    padding: 40px;
    .form-section {
      margin-bottom: 30px;
    }
    .status {
      margin-bottom: 10px;
    }
  }
  .md-dialog {
    width: 50%;
    min-width: 50%;
  }
  .geo-approach {
    margin-right: 20px;
  }
  .domains-form {
    width: 100%;
  }
  .platforms-form {
    width: 100%;
  }
  .pricing-form {
    width: 100%;
  }
  .md-chips {
    width: 100%;
  }
  #approach {
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/LicenseFormDialog.vue